




















































































































































import GoToReferenceButton from "@/components/partner/GoToReferenceButton.vue";
import SideCard from "@/components/utility/SideCard.vue";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { SignDocumentViewModelGen } from "@/services/sign/v1/data-contracts";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import DocumentDetailMixin from "./DocumentDetailMixin.vue";

@Component({
  components: {
    SideCard,
    GoToReferenceButton
  }
})
export default class DocumentTemplateDetailInformation extends mixins(DocumentDetailMixin) {
  @Prop()
  document!: SignDocumentViewModelGen;

  edit = false;

  get partnerId() {
    return this.document.partnerId;
  }

  get name() {
    const name = this.document.name;
    if (name?.endsWith(".pdf")) {
      return name.slice(0, name.length - 4);
    }

    return name ?? "";
  }

  set name(name: string) {
    if (!name.endsWith(".pdf")) {
      this.document.name = `${name}.pdf`;
    } else {
      this.document.name = name;
    }
  }

  get subtitle() {
    return `
      ${this.$t("sign.DocumentTemplateDetailInformation.created")}:
      ${simpleDoubleDigitDate(this.document.timestamp?.created)}
    `;
  }

  get mainContainerStyle() {
    return `
      height: calc(100vh ${this.isMobile ? "- 157px" : "- 157px - 26px - 68px - 32px - 50px"});
      overflow-y: auto;
    `;
  }

  save() {
    this.edit = false;
    this.$emit("save");
  }
}
